<template>
  <button class="start-btn" :class="type" :style="widthStyle" @click="handleTry">
    {{ text }}
    <slot name="icon">
      <ArrowRight class="icon" filled />
    </slot>
  </button>
</template>

<script lang="ts" setup>
/** 开发场景详情时，改成了通用，但是没有移动位置 */

import type { CSSProperties } from 'vue';
import ArrowRight from '~/assets/svg/icon-arrow-right.svg?component';
const props = withDefaults(
  defineProps<{
    text?: string;
    type?: string;
    widthStyle?: CSSProperties;
    handler?: () => void;
  }>(),
  {
    text: '免费试用',
    type: 'default',
  },
);
const handleTry = () => {
  if (props.handler) {
    props.handler();
    return;
  }
  const userInfo = useUserInfo();
  if (!userInfo.value) {
    navigateTo(
      `/login?redirect=${encodeURIComponent(encodeURIComponent(`${location.origin}/workspace`))}`,
    );
  } else {
    location.href = '/workspace';
  }
};
</script>

<style lang="scss" scoped src="./styles/pc.scss" />
<style lang="scss" scoped src="./styles/mobile.scss" />
